import React, { useState, useRef, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { navActive, PAGES_PATHS, ACTIVITY_PATHS } from './navActive';
import BrandLogo from '../BrandLogo';

function MobileMenu({ isOpen, onClose }) {
    const { pathname } = useLocation();
    const [activeMenu, setActiveMenu] = useState(null);
    const menuRefs = useRef({});

    const toggleMenu = (index) => {
        setActiveMenu(activeMenu === index ? null : index);
    };

    useEffect(() => {
        Object.keys(menuRefs.current).forEach((key) => {
            const submenu = menuRefs.current[key];
            if (submenu) {
                submenu.style.height = activeMenu == key ? `${submenu.scrollHeight}px` : '0px';
            }
        });
    }, [activeMenu]);

    useEffect(() => {
        if (isOpen) {
            onClose();
        }
        // Close when the route changes (after a nav tap)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pathname]);

    useEffect(() => {
        document.body.style.overflow = isOpen ? 'hidden' : '';
        document.body.classList.toggle('twa-menu-open', isOpen);
        return () => {
            document.body.style.overflow = '';
            document.body.classList.remove('twa-menu-open');
        };
    }, [isOpen]);

    const go = () => onClose();

    return (
        <div
            className={`th-menu-wrapper onepage-nav ${isOpen ? 'th-body-visible' : ''}`}
            style={{ visibility: isOpen ? 'visible' : 'hidden' }}
            onClick={onClose}
            role="dialog"
            aria-modal="true"
            aria-hidden={!isOpen}
        >
            <div className="th-menu-area text-center" onClick={(e) => e.stopPropagation()}>
                <div className="twa-menu-head">
                    <div className="mobile-logo">
                        <BrandLogo />
                    </div>
                    <button className="th-menu-toggle twa-menu-close" onClick={onClose} aria-label="Close menu" type="button">
                        <i className="fal fa-times" />
                    </button>
                </div>

                <div className="th-mobile-menu">
                    <ul>
                        <li>
                            <Link className={navActive(pathname, '/', { exact: true })} to="/" onClick={go}>
                                Home
                            </Link>
                        </li>
                        <li>
                            <Link className={navActive(pathname, '/about', { exact: true })} to="/about" onClick={go}>
                                About Us
                            </Link>
                        </li>
                        <li>
                            <Link className={navActive(pathname, '/destination')} to="/destination" onClick={go}>
                                Destinations
                            </Link>
                        </li>
                        <li>
                            <Link className={navActive(pathname, '/service')} to="/service" onClick={go}>
                                Services
                            </Link>
                        </li>
                        <li>
                            <Link className={navActive(pathname, ACTIVITY_PATHS)} to="/activities" onClick={go}>
                                Activities
                            </Link>
                        </li>
                        <li className={`menu-item-has-children th-item-has-children ${activeMenu === 5 ? 'th-active' : ''}`}>
                            <Link
                                className={navActive(pathname, PAGES_PATHS)}
                                to="/tour"
                                onClick={(e) => {
                                    if (activeMenu !== 5) {
                                        e.preventDefault();
                                        toggleMenu(5);
                                    } else {
                                        go();
                                    }
                                }}
                            >
                                Tours
                            </Link>
                            <ul
                                ref={(el) => {
                                    menuRefs.current[5] = el;
                                }}
                                className="th-submenu"
                                style={{ height: '0px', overflow: 'hidden', transition: 'height 0.3s ease-in-out' }}
                            >
                                <li>
                                    <Link className={navActive(pathname, '/gallery', { exact: true })} to="/gallery" onClick={go}>
                                        Gallery
                                    </Link>
                                </li>
                                <li>
                                    <Link className={navActive(pathname, '/faq', { exact: true })} to="/faq" onClick={go}>
                                        FAQ
                                    </Link>
                                </li>
                            </ul>
                        </li>
                        <li>
                            <Link className={navActive(pathname, '/blog')} to="/blog" onClick={go}>
                                Blog
                            </Link>
                        </li>
                        <li>
                            <Link className={navActive(pathname, '/contact', { exact: true })} to="/contact" onClick={go}>
                                Contact Us
                            </Link>
                        </li>
                        <li className="mt-3">
                            <Link to="/tour" className="th-btn th-icon" onClick={go}>
                                Book Now
                            </Link>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    );
}

export default MobileMenu;
